"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const search_svg_1 = __importDefault(require("images/utility-icons/search.svg"));
function EmptyState() {
    return ((0, jsx_runtime_1.jsxs)("section", { className: "empty-state", children: [(0, jsx_runtime_1.jsx)("img", { src: search_svg_1.default, alt: "" }), (0, jsx_runtime_1.jsx)("h2", { children: "No Matches Available" }), (0, jsx_runtime_1.jsx)("p", { children: "Sorry, looks like the page you're looking for was moved or doesn't exist." })] }));
}
exports.default = EmptyState;
